(function () {
  "use strict";

  if (window.__pageflyCartSyncInstalled) return;
  window.__pageflyCartSyncInstalled = true;

  const ADD_TO_CART = /\/cart\/add(\.js)?(\?|$)/;
  const parser = new DOMParser();

  function isThemeOwnAdd(body) {
    if (body instanceof FormData) return body.has("sections");
    return typeof body === "string" && body.includes("sections");
  }

  function syncCart() {
    fetch(window.routes.cart + "?sections=main-cart")
      .then((response) => response.json())
      .then((data) => {
        window.themeCart.renderItems(parser.parseFromString(data["main-cart"], "text/html"));

        const drawer = document.getElementById("mini-cart");
        if (window.cartStrings.uxCart === "mini-cart" && !drawer.classList.contains("open")) {
          drawer.open();
        }
      })
      .catch((error) => console.error("[pagefly-cart-sync]", error));
  }

  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : (input && input.url) || "";
    const promise = nativeFetch.apply(this, arguments);
    if (ADD_TO_CART.test(url) && !isThemeOwnAdd(init?.body)) {
      promise.then((response) => { if (response.ok) syncCart(); }).catch(() => {});
    }
    return promise;
  };
})();
